export default "__VITE_ASSET__BqAIOdZZ__"